export default __webpack_public_path__ + "static/media/foto-card-suvinil.b2678922.jpg";